module.exports = __webpack_public_path__ + "img/heart-2.a371c84b.svg";